"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UrlParts = _interopRequireDefault(require("./parts/UrlParts"));

/*
 * IMPORTANT
 * ------------
 * The frontend is not capable of properly validating email addresses.
 * See https://git.hubteam.com/HubSpot/PatternValidation/issues/49
 *
 * Because of this, it is required to validate on the backend for any
 * scenario that prompts a user in product for an email address.
 *
 * More info - https://product.hubteam.com/docs/frontend/docs/input-validation.html
 */
var EMAIL_ADDRESS_REGEX = new RegExp("^(?:.+)@" + _UrlParts.default.domain + "$");
var _default = EMAIL_ADDRESS_REGEX;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.189/js/regex/EmailAddressRegex.js
// module id = 250
// module chunks = 0